<template>
	 <div >
        <div class="content">

            <section >

              <h1
                class="center mb-5 text-bold"
                v-html="`Quomi si prende una pausa`"
                >
              </h1>

                <div>
                      
                <!--<p class="gif-container">
                    <img src="https://api.quomi.it/oldimg/salmone_al_melograno_1-thumb-big.jpg" loading="lazy" width='300' >
                </p>-->
                    	<p style="max-width: 800px" class="ma-auto">
                    		<!-- <b>Sembra che la tua connessione attuale non ti consenta di navigare il nostro sito. 
                          Questo può essere legato all'utilizzo di una rete aziendale. Riprova ad accedere utilizzando un'altra rete 
                          o un dispositivo con rete mobile. In caso di problemi non esitare a scriverci. Trovi i contatti in fondo alla pagina!
                        </b><br><br> -->
                        La nostra cucina si prende una piccola pausa per qualche intervento di manutenzione utile a migliorare il nostro servizio. Non vediamo l’ora di poter tornare quanto prima in cucina con voi!
                        <br><br>
							         
                        <div class="tag-partner ma-auto" style="max-width:400px">
                          <p>
                            Lascia qui la tua mail per essere avvisato non appena il servizio tornerà operativo:

                          </p>
                        
                          <div class="form flex-vcenter">
                            <input
                              type="email"
                              class="form-control"
                              v-model="email"
                              placeholder="Inserisci la tua mail"
                              autocomplete="email"
                            >
                          </div>
                          
                          <div class="text-center">
                            <CTA
                              class="ma-auto my-3"
                              :content="`Conferma `"
                              :size="`small`"
                              @click="$_newsletter_newsletterList({ list: list, email: email })"
                            />
                          </div>
                            
                          <br>
                          <flash
                            v-if="newsletterFlash"
                            :flash="newsletterFlash"
                            :state="newsletterState"
                          />
                        </div>
                        <p style="max-width: 800px" class="ma-auto tag-partner">Nel frattempo puoi continuare a navigare  <b><router-link class="link-detail" :to="{'name': 'cookbook'}">il nostro ricettario</router-link></b>  per trovare idee e ispirazione per le tue cene!</p>
                        <br>
                        <p>
                          Non vediamo l’ora di tornare a cucinare insieme 😊<br>
                          <br>
                        </p>
                    </p>	
                </div>
            </section>
         </div>
    </div>
</template>

<script>

import { newsletter } from '../../mixins/newsletter'
import Flash from '../Parts/Flash'

export default {
  mixins : [
    newsletter
  ],
  components: {
    Flash
  },
  data: function () {
    return {
      email: null,
      list:'nat-2022'
    }
  },
	computed: {
        user () {
            return this.$root.user
        }
    }
}

</script>

<style scoped>
    .label {
        background-color: #fbf1d7;
        max-width: 500px;
        margin: 0 auto;
        margin-bottom: 10px;
    }

    .content {
        padding: 30px 15px 30px 15px;
        text-align: center;
        width: 100%;
        max-width: 100%;
    }

    .gif-container {
        margin: 0 auto;
        overflow: hidden;
        margin-bottom: 20px;
    }

    .gif-container img {
        max-width: inherit;
        margin-left: -16px;
    }

    .container-faq {
        max-width: 1200px;
        width: 90%;
        margin: 0 auto;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    h2 {
        padding-bottom: 10px;
    }

    h3 {
        font-size: 20px;
    }

    .red-text {
        margin: 0 auto;
        display: block;
        font-size: 15px;
        font-weight: bold;
    }

    section {
      width: 100%;
      max-width: 1240px;
      margin-left: auto;
      margin-right: auto;
    }

    .gift-dashboard {
      background-image: url('https://api.quomi.it/oldimg/natale-quomi-header-aziende.webp');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center 35%;
    }

    @media only screen and (max-width: 768px) {
      h1 {
        font-size: 26px;
      }
      .dashboard >>> .shadow-box:not(.recipe):not(.slider-arrow)::after,
      .dashboard >>> .shadow-box:not(.recipe):not(.slider-arrow)::before {
        display: none;
      }

      .dashboard >>> .shadow-box:hover {
        box-shadow: none;
      }

      .container >>> .section-content {
        padding: 30px 20px;
      }

      .news-cards {
        flex-direction: column;
      }
    }
</style>
